module.exports = __webpack_public_path__ + "static/img/2.35919ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/video-group/2.jpg
// module id = qQLA
// module chunks = 1